<template>
  <div class="masthead"> 
    <div class="braning"> 
      <div>Tao西雅图-美洲最佳援交中介 | 8年老牌 | 靠谱约炮</div>
      <div>Tao家 – 美洲第一伴君品牌</div>
    </div> 
    <header >
        <!-- <img src="@/assets/Artboard-2.svg" srcset="@/assets/Artboard-2.svg" alt="顶部图片" />  -->
        
        <div class="logo">
          <img src="@/assets/logo25.png" srcset="@/assets/logo25.png" alt="顶部图片" /> 
          <div class="logo-text">
            Tao家 – 西雅图第一伴君品牌
          </div>
        </div>
    
      <NavBar/>  
    </header>
  </div>
</template>

<script setup>
import NavBar from '@/components/NavBar.vue'
 
</script>

<style lang="scss" scoped>
// @import "@/assets/css/head.scss"; 

@media screen and (max-width: 767px){
  .masthead::after{  
      height: 8rem !important;  
  } 
  header>.logo>.logo-text{
    font-size: 18px!important;
    transform: translate(-33%, -10%)!important;
    left: 40%!important;
    bottom: 1.5rem!important;
  }
} 

$underline-duration: 0.3s;
.masthead{
    position: relative; 
    top: 0 !important;
    width: 100%; 
    max-width: 100%;
    background: #020221 url(@/assets/herald.png) repeat center center;
    background-size: auto;

    .braning{
        justify-content: center;
        flex: 1 1 100%;
        display:flex;
        line-height: 0;
        font-size: 0;
    }

    header {
      max-width: calc(1300px - 100px);
      margin: 0 auto;
      background-color: var(--wpcomm-color-red);
      img {
        width: 300px;
        height: 252px;
      }
      .logo{
        position: relative;     
        // background-color: #020221;
        .logo-text{
          position: absolute; 
          bottom: 0.3rem;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 28px;
          font-weight: bold;
          background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
          -webkit-background-clip: text !important;
          -webkit-text-fill-color: transparent;
        }
      }
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0rem;
      left: 0;
      width: 100%;
      height: 4rem;
      background: #040435;  
    }
}


</style>